import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { getDealCodeList, getDealFormatList, getDealRegionsList, getSongListingsList } from '~/features/dashboard/store/selectors';
import { sortItems, sortSongItems } from '~/utils/helpers';
import { getDealCodes, getDealFormats, getDealRegions, getSongListings } from '~/features/dashboard/store/actions.thunks';
import classNames from 'classnames';
import { Box, Divider, Drawer, Grid, IconButton, ListItem, ListItemText, Typography } from '@material-ui/core';
import { CodesListDrawer, FormatsListDrawer, ItemType, RegionsListDrawer } from '~/features/dashboard/components/editable-list-drawer';
import { ItemTypeSong } from '~/features/dashboard/components/song-details/coponents/EditSynchTab';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import { CollapsibleBlock } from '~/features/dashboard/components/collapsible-block';
import { PageBlock } from '~/features/dashboard/components/page-block';
import { EditSynchTab } from '~/features/dashboard/components/song-details/coponents/EditSynchTab';


interface ContentProps {
    user: any;
    tab: number;
    changeData: any;
}

enum DRAWER_TYPES {
    FORMAT = 'FORMAT',
    REGION = 'REGION',
    CODE = 'CODE',
    GENRE = 'GENRE',
    CONTEXT = 'CONTEXT',
    MOOD = 'MOOD',
    ERA = 'ERA',
    CLASSIFICATION = 'CLASSIFICATION',
    BEHAVIOUR = 'BEHAVIOUR',
}

export const ProfileListings: React.FC<ContentProps> = ({user, tab, changeData}) => {

    const dispatch = useThunkDispatch();

    const dealListings = [
        {type: 'REGION', label: 'Regions'},
        {type: 'CODE', label: 'Recoupables'},
        {type: 'FORMAT', label: 'Rate Formats'},
    ];

    const songListings = [
        {type: 'GENRE', label: 'Genre'},
        {type: 'CONTEXT', label: 'Context'},
        {type: 'MOOD', label: 'Mood'},
        {type: 'ERA', label: 'Era'},
        {type: 'CLASSIFICATION', label: 'Classification'},
        {type: 'BEHAVIOUR', label: 'Behaviour'},
    ];

    const [openDeals, setOpenDeals] = useState(true);
    const [openSongs, setOpenSongs] = useState(true);
    const [activeItem, setActiveItem] = useState(`${DRAWER_TYPES.REGION}`);
    // const [searchValue, setSearchValue] = useState('');

    const allRoyaltyRateFormats = useSelector(getDealFormatList);
    const royaltyRateFormats: ItemType[] = useMemo(() => {
        if (allRoyaltyRateFormats && allRoyaltyRateFormats.length) {
            return sortItems(allRoyaltyRateFormats.map(i => ({ id: i.customField ? i.formatId : 0, title: i.formatDesc })));
        }
        return [];
    }, [allRoyaltyRateFormats]);

    let allRecoupableCodes = useSelector(getDealCodeList);
    let recoupableCodes: ItemType[] = useMemo(() => {
        if (allRecoupableCodes && allRecoupableCodes.length) {
            return sortItems(allRecoupableCodes.map(i => ({ id: i.customField ? i.id : 0, title: i.analysisText })));
        }
        return [];
    }, [allRecoupableCodes]);

    const allRegions = useSelector(getDealRegionsList);
    const countryList: ItemType[] = useMemo(() => {
        if (allRegions && allRegions.length) {
            return sortItems(allRegions.map(i => ({ id: i.customField ? i.id : 0, title: i.regionText })));
        }
        return [];
    }, [allRegions]);

    const allSongListings = useSelector(getSongListingsList);
    const songList: ItemTypeSong[] = useMemo(() => {
        if (allSongListings && allSongListings.length) {
            return sortSongItems(allSongListings.map(i => ({ id: i.customField ? i.id : 0, customField: i.customField ? i.customField : 0, listingText: i.listingText })));
        }
        return [];
    }, [allSongListings]);

    const [drawerData, setDrawerData] = useState<{ isOpen: boolean; type?: DRAWER_TYPES; meta?: any }>({ isOpen: false });
    const closeDrawer = () => {
        if (drawerData.type === DRAWER_TYPES.FORMAT) {
            dispatch(getDealFormats());
        }
        if (drawerData.type === DRAWER_TYPES.REGION) {
            dispatch(getDealRegions());
        }
        if (drawerData.type === DRAWER_TYPES.CODE) {
            dispatch(getDealCodes());
        }
        if (drawerData.type === DRAWER_TYPES.GENRE || drawerData.type === DRAWER_TYPES.CONTEXT || drawerData.type === DRAWER_TYPES.MOOD || drawerData.type === DRAWER_TYPES.ERA || drawerData.type === DRAWER_TYPES.CLASSIFICATION || drawerData.type === DRAWER_TYPES.BEHAVIOUR) {
            dispatch(getSongListings(drawerData.type));
        }
        setDrawerData({ isOpen: false, type: undefined, meta: undefined });
    };
    const openDrawer = (type: DRAWER_TYPES, meta?: any) => {
        setDrawerData({ isOpen: true, type, meta });
    };
    const openFormatDrawer = () => {
        openDrawer(DRAWER_TYPES.FORMAT);
    };
    const openRegionDrawer = () => {
        openDrawer(DRAWER_TYPES.REGION);
    };
    const openCodeDrawer = () => {
        openDrawer(DRAWER_TYPES.CODE);
    };
    const openSongDrawer = (type: any) => {
        openDrawer(type);
    };

    useEffect(() => {
        switch (activeItem) {
            case DRAWER_TYPES.REGION:
                dispatch(getDealRegions());
                break;
            case DRAWER_TYPES.CODE:
                dispatch(getDealCodes());
                break;
            case DRAWER_TYPES.FORMAT:
                dispatch(getDealFormats());
                break;
            case DRAWER_TYPES.GENRE:
                dispatch(getSongListings(DRAWER_TYPES.GENRE));
                break;
            case DRAWER_TYPES.CONTEXT:
                dispatch(getSongListings(DRAWER_TYPES.CONTEXT));
                break;
            case DRAWER_TYPES.MOOD:
                dispatch(getSongListings(DRAWER_TYPES.MOOD));
                break;
            case DRAWER_TYPES.ERA:
                dispatch(getSongListings(DRAWER_TYPES.ERA));
                break;
            case DRAWER_TYPES.CLASSIFICATION:
                dispatch(getSongListings(DRAWER_TYPES.CLASSIFICATION));
                break;
            case DRAWER_TYPES.BEHAVIOUR:
                dispatch(getSongListings(DRAWER_TYPES.BEHAVIOUR));
                break;
            default:
                dispatch(getDealRegions());
                break;
        }
    }, [dispatch, activeItem]);


    return (
        <Grid container className={css.container}>

            <Drawer
                className={css.drawer}
                variant="permanent"
                classes={{ paper: css.drawerPaper }}
            >
                <Toolbar />
                <div className={css.drawerContainer}>

                    {/*<div className={css.moduleAvatar}>*/}
                    {/*    <Avatar alt={user?.fullName} src={user?.image} className={'avatar'} variant={'square'} />*/}
                    {/*    <Typography className={'name'}>{user?.fullName}</Typography>*/}
                    {/*    <Typography className={'email'}>{user?.email}</Typography>*/}
                    {/*</div>*/}
                    {/*<Search search={searchValue} onSearchChange={setSearchValue} className={css.search} />*/}
                    {/*<Divider />*/}

                    <List component="div" disablePadding>
                        <ListItem button onClick={() => {setOpenDeals(!openDeals)}}>
                            <ListItemText primary="Deals" className={css.ListItemText} />
                            {openDeals ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>

                        <Collapse in={openDeals} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {dealListings.map(listing => (
                                    <ListItem key={listing.type} button className={activeItem === `${listing.type}` ? css.listItemActive : css.listItem} onClick={() => {setActiveItem(`${listing.type}`)}}>
                                        <ListItemText primary={`${listing.label}`} />
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </List>

                    <List component="div" disablePadding>
                        <ListItem button onClick={() => {setOpenSongs(!openSongs)}}>
                            <ListItemText primary="Songs" className={css.ListItemText} />
                            {openSongs ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>

                        <Collapse in={openSongs} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {songListings.map(listing => (
                                    <ListItem key={listing.type} button className={activeItem === `${listing.type}` ? css.listItemActive : css.listItem} onClick={() => {setActiveItem(`${listing.type}`)}}>
                                        <ListItemText primary={`${listing.label}`} />
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                    </List>
                </div>
            </Drawer>

            {activeItem === DRAWER_TYPES.REGION && (
                <Grid item xs={12} className={css.grid12}>
                    <PageBlock title="Regions" editAction={openRegionDrawer}>
                        <div className={classNames(css.dataList)}>
                            {countryList.slice(0, 5).map((i: ItemType) => (
                                <ListItem key={i.title}>
                                    <ListItemText primary={i.title} />
                                </ListItem>
                            ))}
                            {countryList.length > 5 && (
                                <CollapsibleBlock>
                                    {countryList.slice(5, countryList.length).map((i: ItemType) => (
                                        <ListItem key={i.title}>
                                            <ListItemText primary={i.title} />
                                        </ListItem>
                                    ))}
                                </CollapsibleBlock>
                            )}
                        </div>
                    </PageBlock>
                </Grid>
            )}

            {activeItem === DRAWER_TYPES.CODE && (
                <Grid item xs={12} className={css.grid12}>
                    <PageBlock title="Recoupable Codes" editAction={openCodeDrawer}>
                        <div className={classNames(css.dataList)}>
                            {recoupableCodes.slice(0, 5).map((i: any) => (
                                <ListItem key={i.title}>
                                    <ListItemText primary={i.title} />
                                </ListItem>
                            ))}
                            {recoupableCodes.length > 5 && (
                                <CollapsibleBlock>
                                    {recoupableCodes.slice(5, recoupableCodes.length).map((i: ItemType) => (
                                        <ListItem key={i.title}>
                                            <ListItemText primary={i.title} />
                                        </ListItem>
                                    ))}
                                </CollapsibleBlock>
                            )}
                        </div>
                    </PageBlock>
                </Grid>
            )}

            {activeItem === DRAWER_TYPES.FORMAT && (
                <Grid item xs={12} className={css.grid12}>
                    <PageBlock title="Rate Formats" editAction={openFormatDrawer}>
                        <div className={classNames(css.dataList)}>
                            {royaltyRateFormats.slice(0, 5).map((i: ItemType) => (
                                <ListItem key={i.title}>
                                    <ListItemText primary={i.title} />
                                </ListItem>
                            ))}
                            {royaltyRateFormats.length > 5 && (
                                <CollapsibleBlock>
                                    {royaltyRateFormats.slice(5, royaltyRateFormats.length).map((i: ItemType) => (
                                        <ListItem key={i.title}>
                                            <ListItemText primary={i.title} />
                                        </ListItem>
                                    ))}
                                </CollapsibleBlock>
                            )}
                        </div>
                    </PageBlock>
                </Grid>
            )}

            {songListings.map(listing => (
                activeItem === listing.type && (
                    <Grid key={listing.type} item xs={12} className={css.grid12}>
                        <PageBlock title={listing.label} editAction={() => openSongDrawer(listing.type)}>
                            <div className={classNames(css.dataList)}>
                                {songList.slice(0, 5).map((i: ItemTypeSong) => (
                                    <ListItem key={i.listingText}>
                                        <ListItemText primary={i.listingText} />
                                    </ListItem>
                                ))}
                                {songList.length > 5 && (
                                    <CollapsibleBlock>
                                        {songList.slice(5, songList.length).map((i: ItemTypeSong) => (
                                            <ListItem key={i.listingText}>
                                                <ListItemText primary={i.listingText} />
                                            </ListItem>
                                        ))}
                                    </CollapsibleBlock>
                                )}
                            </div>
                        </PageBlock>
                    </Grid>
                )
            ))}

            <Drawer variant="persistent" anchor="right" open={drawerData.isOpen} id="deal-edit-step-6-drawer" className={css.rightDrawer}>
                <Box className={css.contentWrapper}>
                    <Box className={css.closeDrawer}>
                        <IconButton onClick={closeDrawer}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography style={{ fontSize: '1rem' }}>Close</Typography>
                    </Box>
                    <Divider />
                    {drawerData.type === DRAWER_TYPES.FORMAT && (
                        <FormatsListDrawer
                            items={royaltyRateFormats}
                        />
                    )}
                    {drawerData.type === DRAWER_TYPES.REGION && (
                        <RegionsListDrawer
                            items={countryList}
                        />
                    )}
                    {drawerData.type === DRAWER_TYPES.CODE && (
                        <CodesListDrawer
                            items={recoupableCodes}
                        />
                    )}
                    {(drawerData.type === DRAWER_TYPES.GENRE || drawerData.type === DRAWER_TYPES.CONTEXT || drawerData.type === DRAWER_TYPES.MOOD || drawerData.type === DRAWER_TYPES.ERA || drawerData.type === DRAWER_TYPES.CLASSIFICATION || drawerData.type === DRAWER_TYPES.BEHAVIOUR) && (
                        <div className={css.editSynchTab}>
                            <EditSynchTab
                                items={songList}
                                title={drawerData.type}
                            />
                        </div>
                    )}
                </Box>
            </Drawer>

        </Grid>
    );
};
